import { render, staticRenderFns } from "./AssignAgentToGroup.vue?vue&type=template&id=a0583f14"
import script from "./AssignAgentToGroup.vue?vue&type=script&lang=js"
export * from "./AssignAgentToGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports